import { render } from "./AiInsights.vue?vue&type=template&id=435958a9"
import script from "./AiInsights.vue?vue&type=script&lang=js"
export * from "./AiInsights.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__